/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {MutationTree} from 'vuex';
import {Vue} from 'vue-property-decorator';
import {
    ContributionListInterface,
    IssueInterface, IssueListInterface, IssuesResultsInterface,
    IssuesStateInterface, VoteInterface,
} from '@/store/modules/issues/types';

export const mutations: MutationTree<IssuesStateInterface> = {

    /**
     * Set the loaded issues.
     *
     * @param {IssuesStateInterface} state
     * @param payload
     *
     */
    issuesLoaded(
        state: IssuesStateInterface,
        payload: IssuesResultsInterface): void {

        const issueList: IssueListInterface = {
            issues: payload.issues,
            pagination: payload.pagination,
            totalItems: payload.totalIssues,
        };

        Vue.set(state, payload.stateName, issueList);
    },

    /**
     * For the error in issues.
     *
     * @param {IssuesStateInterface} state
     *
     */
    issuesError(state: IssuesStateInterface): void {
        Vue.set(state, 'error', true);
    },

    /**
     * Set the loaded issue details.
     *
     * @param {IssuesStateInterface} state
     * @param {IssueInterface} payload
     */
    issueLoaded(state: IssuesStateInterface, payload: IssueInterface): void {
        Vue.set(state, 'currentIssue', payload);
        Vue.set(state, 'error', false);
    },

    /**
     * For the error in issue details.
     *
     * @param {IssuesStateInterface} state
     *
     */
    issueError(state: IssuesStateInterface): void {
        Vue.set(state, 'error', true);
    },


    /**
     * Set the loaded contributors.
     *
     * @param {IssuesStateInterface} state
     * @param {ContributionListInterface} payload
     */
    contributorsLoaded(state: IssuesStateInterface, payload: ContributionListInterface): void {
        Vue.set(state, 'currentContributors', payload);
        Vue.set(state, 'error', false);
    },


    /**
     * For the error in contributors.
     *
     * @param {IssuesStateInterface} state
     *
     */
    contributorsError(state: IssuesStateInterface): void {
        Vue.set(state, 'error', true);
    },

    // todo delete - old code not used
    // /**
    //  * For the error in contributors.
    //  * @param {IssuesStateInterface} state
    //  * @param {ContributorInterface} $contributor
    //  */
    // addContributor(state: IssuesStateInterface, $contributor: ContributorInterface): void {
    //     state.contributors.push($contributor);
    // },

    /**
     * For the error in contributors.
     * @param {IssuesStateInterface} state
     * @param {string} term
     */
    updateSearchTerm(state: IssuesStateInterface, term: string): void {
        Vue.set(state, 'searchTerm', term);
    },

    // maybe use it to update currentIssue for edit
    // /**
    //  * Update currentIssue
    //  * @param {IssuesStateInterface} state
    //  * @param {IssueInterface | undefined} issue
    //  */
    // updateCurrentIssue(state: IssuesStateInterface, issue: IssueInterface | undefined): void {
    //     Vue.set(state, 'currentIssue', issue);
    // },

    /**
     * Update vote
     *
     * @param {IssuesStateInterface} state
     * @param {VoteInterface} votingConfig
     */
    updateVote(state: IssuesStateInterface, votingConfig: VoteInterface): void {
        if ('currentIssue' === votingConfig.stateName) {
            if (state.currentIssue) {
                Vue.set(state.currentIssue, 'vote', votingConfig.vote);
                Vue.set(state, 'error', false);
            }
        }
        if ('currentIssue' !== votingConfig.stateName) {
            if (undefined !== state[`${votingConfig.stateName}Issues`]) {
                const name: IssueListInterface = (state[`${votingConfig.stateName}Issues`] as IssueListInterface);
                const issueState: IssueInterface | undefined = name.issues.find(
                    (issue: IssueInterface) => {
                        return issue.id === votingConfig.issueId;
                    });
                if (undefined !== issueState) {
                    Vue.set(issueState, 'vote', votingConfig.vote);
                    Vue.set(state, 'error', false);
                }
            }
        }
    },

};
